import { Dispatch, SetStateAction, useState } from 'react'
import { Table, TableBody, TableContainer } from '@mui/material'

import { TxLogFormModal } from '../transaction-log-form'
import { THead } from './t-head.component'
import { TBodyRow } from './t-body-row.component'

import { ITransactionLogDto } from 'src/types'

interface IErrorLogsTableProps {
  data: ITransactionLogDto[]
  sort: string
  setSort: Dispatch<SetStateAction<string>>
}

export const TxLogsTable = ({ data, sort, setSort }: IErrorLogsTableProps) => {
  const [formInitValues, setFormInitValues] = useState<ITransactionLogDto | null>(null)

  const handleSortChange = (sortName: string) => () => {
    setSort((prevSort) =>
      prevSort.split('-')[1] === 'asc' ? `${sortName}-desc` : `${sortName}-asc`,
    )
  }

  const handleOpen = (val: ITransactionLogDto) => () => {
    setFormInitValues(val)
  }

  const handleClose = () => {
    setFormInitValues(null)
  }

  return (
    <>
      <TableContainer>
        <Table>
          <THead 
            sort={sort} 
            handleSortChange={handleSortChange} 
          />
          <TableBody>
            {data?.map((row) => (
              <TBodyRow key={row.id} row={row} handleOpen={handleOpen(row)} />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <TxLogFormModal
        handleClose={handleClose}
        open={!!formInitValues}
        formValues={formInitValues}
      />
    </>
  )
}
